module.exports = __webpack_public_path__ + "imgs/navigation.51c61a4a89072740cd47ccaaa3b87e01.svg";